/* eslint-disable camelcase */
export const USER_INFO_FETCH_REQUEST = 'USER_INFO_FETCH_REQUEST';
export const USER_INFO_FETCH_SUCCESS = 'USER_INFO_FETCH_SUCCESS';
export const USER_INFO_FETCH_FAIL = 'USER_INFO_FETCH_FAIL';
